import { createApiCall } from 'lib/base';

const FETCH_NHSV_WEBHOOK_CONFIGS = 'FETCH_NHSV_WEBHOOK_CONFIGS';

const apiCall = createApiCall(FETCH_NHSV_WEBHOOK_CONFIGS, () => ({
  endpoint: 'api/admin/nhsv/webhook/configs',
  method: 'GET',
}));

export default apiCall;
